export const EVENTS = {
  LOAD: 'LOAD',
  START_OVER: 'START_OVER',
};
